import React from "react";
import { Paths } from "../constants/UrlConstants";

export default {
  DiscoverText: "Discover",
  Heading: "Health Information",
  SubHeading: {
    HOL: <h2>Unlock health support</h2>,
    Any: <h2>Search for health conditions</h2>
  },
  Description: {
    HOL: (
      <React.Fragment>
        <p>
          Whether it's you or a loved one living with a health concern getting
          the information you need at the time when it can help the most can be
          life changing.
        </p>
        <p>
          By bringing health organisations and people together HealthUnlocked is
          pioneering a change in the way people get information, support and
          resources to help them better manage their health condition. We're
          working closely with them to bring their service directly to you
          through Customer Online. So you can read up on the latest condition
          specific information, find local support groups close by or share
          symptoms and experiences with someone who has the same health concern.
        </p>
        <p>
          Simply pop in your postcode, type in a health condition and choose
          from those displayed.
        </p>
      </React.Fragment>
    ),
    Any: (
      <p>
        Find information online and local services with{" "}
        <strong>HealthUnlocked</strong>, helping you to manage and understand
        your health.
      </p>
    )
  },
  PostcodeLabel: "Your postcode",
  SearchLabel: "Search condition",
  PostcodeTooltip:
    "We use your postcode to help find information for you on services that are local to your area. To change the location, you can enter a new postcode here.",
  Disclaimer: (
    <React.Fragment>
      <p>
        These services are provided by other websites - by clicking the links
        you will be directed out of this site.
      </p>
      <p>
        If you need to discuss any questions or concerns relating to your search
        you can speak to our team of nurses, pharmacists and midwives any time,
        day or night on <strong>0800 003 004</strong>.
      </p>
    </React.Fragment>
  ),
  BrowseLink: "Browse another condition",
  BrowseLinkTo: Paths.HealthInformation,
  PopupHeading: "You are now leaving our website",
  PopupDescription: (
    <React.Fragment>
      <p>
        By clicking on Continue you'll be leaving this site and will be directed
        to HealthUnlocked or one of their partner sites.
      </p>
      <p>
        Please note: this information shouldn't replace the need to see a health
        professional.
      </p>
    </React.Fragment>
  ),
  PopupContinueButtonLabel: "Continue",
  PopupCancelButtonLabel: "Cancel",
  PopupBackLinkLabel: "Back"
};
